goog.provide("shadow.js.shim.module$$tiptap$extension_blockquote");
goog.provide("module$shadow_js_shim_module$$tiptap$extension_blockquote");
shadow.js.shim.module$$tiptap$extension_blockquote = shadow.js.nativeProvides["@tiptap/extension-blockquote"] = shadow$bridge("@tiptap/extension-blockquote");
module$shadow_js_shim_module$$tiptap$extension_blockquote.default = shadow.js.shim.module$$tiptap$extension_blockquote;
